import { FC } from 'react';
import CommonPage from '../components/page/CommonPage';
import WebList from '../components/web/WebList';

const WebListPage : FC= () => {

    return (
        <CommonPage selectBtnIndex={3}>
            <WebList />
        </CommonPage>
    )
}

export default WebListPage;